/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type TicketsListEntryTypeItem = typeof TicketsListEntryTypeItem[keyof typeof TicketsListEntryTypeItem];


export const TicketsListEntryTypeItem = {
  deferred: 'deferred',
  emergency: 'emergency',
  inspection: 'inspection',
  modernization: 'modernization',
  regular: 'regular',
  repair: 'repair',
  visit: 'visit',
} as const;
